import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { smallBannersDataProvider } from './dataProvider';

registerModuleDataProvider('small-banners', smallBannersDataProvider);
